import '.a{display:flex;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.cl{height:2.5rem;}.ssr-plugin'
import '.e6{justify-content:flex-end;}.ssr-plugin'
import '.bx{position:relative;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.a7{width:100%;}.ssr-plugin'
import '.dw{padding-inline:1rem;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.cq{position:sticky;}.ssr-plugin'
import '.cf{top:0;}.ssr-plugin'
import '.cr{z-index:10;}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.ax{max-width:77.5rem;}.ssr-plugin'
import '.a8{justify-content:space-between;}.ssr-plugin'
import { useCallback } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { MegaMenu } from '../../megaMenu/MegaMenu.desktop'
import { HoverTabs } from '@app/components/core/tabs/HoverTabs'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { TextLink } from '@app/components/core/link/TextLink'
import useTransform from '@app/util/useTransform'
import { pages } from '@app/util/links'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { useLocation } from 'wouter'
import { authTabs } from '../../authentication/authTabs'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const ACCOUNT_SLOT_WIDTH = '14rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

const AuthButtons = () => {
  const { showAuthModal } = useAuthModal()

  return (
    <div className="a c aj"
    >
      <Button
        variant="secondary"
        label="Log in"
        onClick={() => showAuthModal(authTabs.login)}
        style={{
          whiteSpace: 'nowrap',
        }}
      />
      <Button
        variant="primary"
        label="Meld je aan"
        onClick={() => showAuthModal(authTabs.signUp)}
        style={{
          whiteSpace: 'nowrap',
        }}
      />
    </div>
  )
}

export const TopNavBar = ({ userName, avatar, isLoading }: TopNavBarProps) => {
  const translations = useTranslations().app.nav
  const transformStyle = useTransform('center')
  const [, navigate] = useLocation()

  const renderAccountSection = useCallback(() => {
    if (isLoading) {
      return (
        <div className="cl"
          style={{
            width: ACCOUNT_SLOT_WIDTH,}}
        />
      )
    }
    return userName ? (
      <div className="a e6"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <ProfileMenu>
          <div className="bx a b c ap"
          >
            <Avatar
              size="small"
              labelSource={userName}
              image={avatar}
              onClick={() => navigate(pages.dashboard)}
            />
          </div>
        </ProfileMenu>
      </div>
    ) : (
      <div className="a e6"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <AuthButtons />
      </div>
    )
  }, [isLoading, userName, avatar, navigate])

  return (
    <div className="a7 dw a g cq cf cr co"
    >
      <styled.nav className="co a7 ax a a8 c"
        style={{
          ...transformStyle,
        }}
      >
        <TextLink
          to={pages.home}
          noHover={true}
          isBold={false}
          hasIcon={false}
          textStyle={{ lineHeight: 0 }}
        >
          <Image src={fullLogo} alt="Crowdbuilding Logo" />
        </TextLink>
        <HoverTabs.Group>
          <HoverTabs.Tab label={translations.find}>
            <MegaMenu variant={'find'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.start}>
            <MegaMenu variant={'start'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.learn}>
            <MegaMenu variant={'learn'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.aboutUs}>
            <MegaMenu variant={'aboutUs'} />
          </HoverTabs.Tab>
        </HoverTabs.Group>
        {renderAccountSection()}
      </styled.nav>
    </div>
  )
}
